import React from 'react'

import AnimalStatus from '#/components/Datasheets/AnimalStatus'
import { useFarmSlug } from '#/store/ducks/farm'
import { endpoint } from '#/store/services/endpoints'

const TypeAnimalStatus = ({ value }) => {
  const farmSlug = useFarmSlug()
  if (!value) return <span>-</span>

  let controller = endpoint.farm.animal.status({
    farm: farmSlug,
    animal: value['animal.slug'],
  })
  return <AnimalStatus route={controller} event={value} />
}

export default TypeAnimalStatus
